export default __webpack_public_path__ + "media/440ef82cd6e1092385ac47e1554fa9c3e419f5adf1e0058e8c26f10cad60f56e.svg";